import { render, staticRenderFns } from "./PoiEdit.vue?vue&type=template&id=d6bf510c&scoped=true&"
import script from "./PoiEdit.vue?vue&type=script&lang=js&"
export * from "./PoiEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bf510c",
  null
  
)

export default component.exports